import { Children, ReactNode, FC } from 'react';

import cn from 'clsx';
import { UIHeading1, UIHeading2 } from '@cian/ui-kit';

import { TITLE_FORM, ETestIds } from '../../constants';
import { useIsDesktop } from '../../hooks/useIsDesktop';

import styles from './styles.css';
import { ERuntimeSettings } from '../../../common/types/runtimeSettings';
import { useApplicationContext } from '../../../common/utils/applicationContext';

export interface IFormProps {
  children: ReactNode;
}

export const Form: FC<IFormProps> = ({ children }) => {
  const isDesktop = useIsDesktop();
  const { config } = useApplicationContext();
  const isProgramFilterFieldEnabled = config.get<boolean>(ERuntimeSettings.programFilterFieldEnabled) ?? false;

  const Title = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <div>
      <Title>{TITLE_FORM}</Title>
      <form
        className={cn(
          styles['form'],
          isDesktop && styles['desktop'],
          isProgramFilterFieldEnabled && styles['with-benefit-programs'],
        )}
        data-testid={ETestIds.Form}
      >
        {Children.map(children, child => {
          if (!child) {
            return null;
          }

          return <div className={styles['field']}>{child}</div>;
        })}
      </form>
    </div>
  );
};

Form.displayName = 'Form';
